<template>
  <v-data-table
    :headers="headers"
    :items="indicacoesDesempenho"
    :search="opcoes.pesquisa"
    :sort-by="opcoes.ordenarPor"
    :sort-desc="opcoes.decrescente"
    class="elevation-0"
    item-key="id"
    show-expand
    single-expand
  >
    <template v-slot:top>
      <v-row>
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              INDICAÇÕES DE DESENVOLVIMENTO
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <app-sort v-model="opcoes" />
        </v-col>
        <v-col
          cols="0"
          md="4"
        />
        <v-col
          cols="12"
          md="4"
        >
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- complexidade -->
    <template v-slot:[`item.complexidadeResponsabilidade`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-col v-on="on">
            {{ item.complexidadeResponsabilidade.nome.toUpperCase() }}
          </v-col>
        </template>
        <span>{{ item.complexidadeResponsabilidade.descricao }}</span>
      </v-tooltip>
    </template>

    <!-- competências - expansível -->
    <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="100%"
            text
            width="100%"
            @click="
              expand(!isExpanded);
              generateColumns(colunas, item.competenciasTecnicas);
            "
            v-on="on"
          >
            <v-badge right>
              <template v-slot:badge>
                <span>{{ item.competenciasTecnicas.length }}</span>
              </template>
              <v-icon
                color="grey lighten-0"
                large
              >
                build
              </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Clique para exibir as competências técnicas</span>
      </v-tooltip>
    </template>

    <!-- competências - botão -->
    <template v-slot:expanded-item="{ headers }">
      <td
        :colspan="headers.length"
        class="justify-center"
      >
        <v-row dense>
          <v-spacer />
          <v-col>
            <v-row class="justify-center">
              <h2 class="title primary--text text--darken-1 text-no-wrap">
                COMPETÊNCIAS TÉCNICAS
              </h2>
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <v-simple-table
              class="elevation-0 mb-4"
              dense
            >
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="column in colunas.lista"
                    :key="column.id"
                  >
                    <td
                      v-for="competencia in column"
                      :key="competencia.nome"
                      width="30%"
                    >
                      <div class="d-flex flex-row ma-1">
                        <span
                          :class="
                            competencia.tipo === 'GERAL'
                              ? 'secondary--text'
                              : 'grey-text text--darken-2'
                          "
                        >{{ competencia.nome }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-spacer />
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaIndicacaoDesenvolvimento',

  components: { AppSort, AppSearch },

  props: {
    indicacoesDesempenho: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'SERVIDORES',
          value: 'nomeUsuario',
          width: '25%',
          sortable: false,
        },
        { text: 'RESPONSABILIDADE', value: 'tituloResponsabilidade', sortable: false },
        {
          text: 'COMPLEXIDADE',
          value: 'complexidadeResponsabilidade',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'COMPETÊNCIAS TÉCNICAS',
          value: 'data-table-expand',
          width: '10%',
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nomeUsuario',
        selecionado: { id: 'nomeUsuario', descricao: 'Nome do Servidor' },
        lista: [
          { id: 'nomeUsuario', descricao: 'Nome do Servidor' },
          { id: 'tituloResponsabilidade', descricao: 'Responsabilidade' },
          { id: 'complexidadeResponsabilidade.valor', descricao: 'Complexidade' },
        ],
      },
      colunas: {
        id: '',
        lista: [],
      },
    };
  },

  methods: {
    generateColumns(columns, itens) {
      columns.id = '';
      columns.lista = [];
      const mid = Math.ceil(itens.length / 3);

      for (let col = 0; col < mid; col += 1) {
        columns.id = col;
        columns.lista.push(itens.slice(col * 3, col * 3 + 3));
      }
    },
  },
};
</script>
